import React, { useState } from 'react';
import { User, Settings, Globe, Home, HelpCircle, ChevronRight } from 'lucide-react';
import TranslateIcon from '@mui/icons-material/Translate';
import PaletteIcon from '@mui/icons-material/Palette';
import AccountCircleIcon from '@mui/icons-material/AccountCircle';
import HomeFilledIcon from '@mui/icons-material/HomeFilled';
import ChatBubbleIcon from '@mui/icons-material/ChatBubble';
import GeocodingControl from '../MapControls/GeocodingControl';
import RenderHomeButtonnContent from './SettingsComponents/Home';

const sanitizeImageSrc = (value) => {
  if (typeof value !== 'string') {
    return null;
  }

  try {
    const parsed = new URL(value, window.location.origin);
    const isAllowedBlob = parsed.protocol === 'blob:';
    const isAllowedHttp = (parsed.protocol === 'https:' || parsed.protocol === 'http:')
      && parsed.origin === window.location.origin;

    if (isAllowedBlob || isAllowedHttp) {
      return parsed.href;
    }
  } catch {
    
  }

  return null;
};



const SettingsComponent = ({ isOpen, onClose, userInformation, profilepicture }) => {

  const [activeSection, setActiveSection] = useState('profile');
  
  const [active, setActive] = useState(null);
    const safeProfilePicture = sanitizeImageSrc(profilepicture);

  const images = [
    { id: 'light', src: '/assets/LightMode.png' },
    { id: 'dark', src: '/assets/DarkMode.png' }
  ];

  const supportImages = [
    { id: 'support', src: '/assets/LDSupport1.png' },
    { id: 'gbnet', src: '/assets/LDGBNet1.png' }
  ];

  function extractQueryParams(url) {
    const query = url.split("?")[1];
    return `(${query})`;
  }
  const getCurrentShareLink = () => {
   
    let linkToShare =  window.location.href;
    if(linkToShare.includes("3d-view"))
    {
      linkToShare = sessionStorage.getItem("ShareURL");
    }
    return linkToShare;
  };


  const handleSupportClick = (imgID) => {
    const link = getCurrentShareLink();
    console.log(imgID)
    if(imgID =="support")
      {
        window.open("https://goldbeck.sharepoint.com/sites/zentrale-dokumente/Freigegebene%20Dokumente/260302_BauGIS1.0_Anleitung_DE_CI.pdf","_blank")
      }
    else{

       window.open("https://goldbeck.sharepoint.com/sites/wissen-wissenswertes-fuer-meinen-arbeitsalltag/SitePages/Lageplan-Designer.aspx?", "_blank");
      }
   
    };

    const shouldShowPanel = (url) => {
    return url.includes('/3d-view');
    };


  const languages = [
  { code: 'de', label: 'Deutsch', flag: '/assets/GermanLanguage.png' },
  { code: 'en', label: 'English', flag: '/assets/EnglishLanguageLogo.png' },
  ];


  const [selected, setSelected] = useState(languages[0]);
  const [isDropDownOpen, setIsDropDownOpen] = useState(false);

  const toggleDropdown = () => setIsDropDownOpen((prev) => !prev);

  const selectLanguage = (lang) => {
    setSelected(lang);
    setIsDropDownOpen(false);
      };
    

  const sidebarSections = [
    {
      title: 'Account',
      items: [
        { id: 'profile', label: 'Profil', icon: AccountCircleIcon },
        { id: 'personalization', label: 'Personalisieren', icon: PaletteIcon  },
        { id: 'language', label: 'Sprache', icon: TranslateIcon }
      ]
    },
    {
      title: 'BauGIS',
      items: [
        { id: 'home', label: 'Home Button', icon: HomeFilledIcon },
        { id: 'support', label: 'Support', icon: ChatBubbleIcon }
      ]
    }
  ];

  

    const renderProfileContent = () => (
    <div style={{ 
      backgroundColor: '#EEEFF0', 
      borderRadius: '8px', 
      padding: '32px',
      right: 0 ,
      width: 'calc(100% )',
      height:'calc(100% - 0px)',
      
     
    }}>
      <div style={{ 
        display: 'flex', 
        alignItems: 'center', 
        marginBottom: '32px', 
        marginLeft:"56px",
        marginTop:"-15px"
      }}>
        <AccountCircleIcon style={{ 
          width: '30px', 
          height: '24px', 
          color: '#718096', 
          marginRight: '12px' 
        }} />
        <h1 style={{ 
          fontSize: '20px', 
          fontWeight: '600', 
          color: '#2d3748' 
        }}>
          Profil
        </h1>
      </div>
      
      <div style={{ 
        display: 'flex', 
        alignItems: 'center', 
        marginBottom: '32px' ,
        marginLeft:"56px"
      }}>
        <div style={{ 
          width: '60px', 
          height: '60px', 
          backgroundColor: '#ebf8ff', 
          borderRadius: '50%', 
          display: 'flex', 
          alignItems: 'center', 
          justifyContent: 'center', 
          marginRight: '16px'
        }}>
          {safeProfilePicture ? (
            <img 
              src={safeProfilePicture} 
              alt="Profile" 
              style={{ 
                width: '100%', 
                height: '100%', 
                objectFit: 'cover',
                borderRadius: '50%',
                
              }}
            />
          ) : (
            <User size={24} color="#718096" />
          )}
        </div>
        <div>
          <h2 style={{ 
            fontSize: '18px', 
            fontWeight: '500', 
            color: '#2d3748' 
          }}>
            Hallo, {userInformation.givenName}!
          </h2>
        </div>
      </div>

      <div style={{ marginTop: '24px' }}>
        <div style={{ 
          display: 'grid', 
          gridTemplateColumns: '1fr 1fr', 
          gap: '3px' ,
          width: "500px",
          marginLeft:"56px"
        }}>
          <div>
            <h3 style={{ 
              fontSize: '14px', 
              fontWeight: '500', 
              color: '#4a5568', 
              marginBottom: '16px' 
               
            }}>
              Allgemein
            </h3>
            <div style={{ display: 'inline-block', flexDirection: 'column', gap: '16px' }}>
              <div style={{ 
                display: 'inline-flex', 
                justifyContent: 'space-between', 
                alignItems: 'center', 
                paddingTop: '8px', 
                paddingBottom: '8px' ,
                gap:"50px"
      
              }}>
                <span style={{ 
                  fontSize: '14px', 
                  color: '#718096' 
                }}>
                  Position
                </span>
                <span style={{ 
                  fontSize: '14px', 
                  color: '#2d3748' ,
                  
                }}>
                  {userInformation.jobTitle}
                </span>
              </div>
              <div style={{ 
                display: 'inline-flex', 
                justifyContent: 'space-between', 
                alignItems: 'center', 
                paddingTop: '8px', 
                paddingBottom: '8px' ,
                gap:"38px"
              }}>
                <span style={{ 
                  fontSize: '14px', 
                  color: '#718096' 
                }}>
                  Abteilung
                </span>
                <span style={{ 
                  fontSize: '14px', 
                  color: '#2d3748' 
                 
                }}>
                  {userInformation.department}
                </span>
              </div>
              <div style={{ 
                display: 'inline-flex', 
                justifyContent: 'start', 
                alignItems: 'center', 
                paddingTop: '8px', 
                paddingBottom: '8px' ,
                gap:"56px"
              }}>
                <span style={{ 
                  fontSize: '14px', 
                  color: '#718096' 
                }}>
                  Einheit
                </span>
                <span style={{ 
                  fontSize: '14px', 
                  color: '#2d3748' ,
                  textAlign:"end",
                  width:"100%",
                 
                  whiteSpace:"nowrap"
                }}>
                  GOLDBECK Technologies GmbH
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );


  const renderPersonalisierenContent = ()=>
    
    (
          <div style={{ 
              backgroundColor: '#EEEFF0', 
              borderRadius: '8px', 
              padding: '32px',
              right: 0 ,
              width: 'calc(100% )',
              height:'calc(100% - 0px)',
            }}>
            <div style={{ 
              display: 'absolute', 
              alignItems: 'center', 
              marginBottom: '32px' ,
              marginLeft:"56px",
              marginTop:"-15px"
            }}>
              <PaletteIcon style={{ 
                width: '16px', 
                height: '16px', 
                color: '#718096', 
                marginRight: '12px' 
              }} />
              <h1 style={{ 
                fontSize: '20px', 
                fontWeight: '600', 
                color: '#2d3748' 
              }}>
                Personalisieren
              </h1>

            </div>
            <p style={{ color: '#718096',marginLeft:"56px" , maxWidth:"1000px"}}>
              Design
            </p>
             <div style={{ display: 'inline-flex',  justifyContent:"space-between", gap: '40px', marginLeft:"56px"}}>
              {images.map((img) => (
                <button
                  key={img.id}
                  onClick={() => setActive(img.id)}
                  onMouseOver={(e) => e.currentTarget.style.border = '2px solid #3EBAEC'}
                  onMouseOut={(e) => {
                    if (active !== img.id) e.currentTarget.style.border = '2px solid #95999D';
                  }}
                  style={{
                    padding: 0,
                    border: active === img.id ? '2px solid #3EBAEC' : '2px solid #95999D',
                    borderRadius: '8px',
                    cursor: 'pointer',
                    outline:"none",
                    background: 'none'
                  }}
                >
                  <img src={img.src} width="170px" height="120px" alt={`${img.id} mode`} />
                </button>
              ))}
            </div>
        
           
          </div>
        );


  const renderSupportContent = ()=>
    (
          <div style={{ 
              backgroundColor: '#EEEFF0', 
              borderRadius: '8px', 
              padding: '32px',
              right: 0 ,
              width: 'calc(100% )',
              height:'calc(100% - 0px)',
          }}>
            <div style={{ 
              display: 'flex', 
              alignItems: 'center', 
              marginBottom: '32px' ,
              marginLeft:"56px",
              marginTop:"-15px"
            }}>
              <ChatBubbleIcon  style={{ 
                width: '24px', 
                height: '24px', 
                color: '#718096', 
                marginRight: '12px' 
              }} />
              <h1 style={{ 
                fontSize: '20px', 
                fontWeight: '600', 
                color: '#2d3748' 
                
              }}>
                Support
              </h1>
            </div>
            <p style={{ color: '#718096', marginLeft:"56px", fontSize:"13px" }}>
              Wenn du Hilfe benötigst, wende dich an den hier hinterlegten Support. <br />
              Weitere Informationen zum BauGIS findest du im GBNet.
            </p>
            <div style={{ display: 'inline-flex',  justifyContent:"space-between", gap: '10px', marginLeft:"56px", marginTop:"40px"}}>
              {supportImages.map((img) => (
                <button
                  key={img.id}
                  onClick={() => handleSupportClick(img.id)}

                  style={{
                    padding: 0,
                    borderRadius: '8px',
                    cursor: 'pointer',
                    outline:"none",
                    background: 'none'
                  }}
                >
                  <img src={img.src} width="320px" height="218px" alt={`${img.id} mode`} />
                </button>
              ))}
            </div>
          </div> 
      );

  const renderSpracheContent = () => (
    <div style={{ 
             backgroundColor: '#EEEFF0', 
              borderRadius: '8px', 
              padding: '32px',
              right: 0 ,
              width: 'calc(100% )',
              height:'calc(100% - 0px)',
          }}>
            <div style={{ 
              display: 'flex', 
              alignItems: 'center', 
              marginBottom: '32px' ,
              marginLeft:"56px",
              marginTop:"-15px"
              
            }}>
              <TranslateIcon style={{ 
                width: '24px', 
                height: '24px', 
                color: '#718096', 
                marginRight: '12px' 
              }} />
              <h1 style={{ 
                fontSize: '18px', 
                fontWeight: '600', 
                color: '#2d3748' ,
                fontFamily:"GoldbeckNextSemiBold2"
                
              }}>
                Sprache 
              </h1>
            </div>
            <div style={{ display:" grid", width:"655px", height:"120px"}}>
              <p style={{ color: '#27292B',  marginLeft:"56px", fontFamily:"GoldbeckNextSemiBold2", fontWeight:"600px", fontSize:"13px"}}>
              Sprache auszuwählen
            </p>
             <p style={{ color: '#27292B',  marginLeft:"56px", fontFamily:"GoldbeckNextRegular", fontWeight:"600px", fontSize:"13px"}}>
              Passe die Sprache der Anwendung an. Wähle eine verfügbare Sprachen, um die Benutzeroberfläche und Inhalte in der bevorzugten Sprache anzuzeigen. 
            </p>

            <div style={{ position: 'relative', marginLeft:"56px", width: '180px', fontFamily: 'GoldbeckNextRegular', color:"#27292B", fontSize:"13px"}}>
            <div
              onClick={toggleDropdown}
              style={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'space-between',
                background: '#f7f7f7',
                padding: '8px 12px',
                borderRadius: '8px',
                cursor: 'pointer',
                width:"231px",
                height:"25px"
              }}
            >
              <span style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                <img src={selected.flag} alt={`${selected.label} flag`} width="20" height="20" style={{borderRadius:"9999px"}}/>
                <span>{selected.label}</span>
              </span>
              <span style={{ transform: isDropDownOpen ? 'rotate(180deg)' : 'rotate(0)', transition: '0.2s' }}>▼</span>
            </div>

            {isDropDownOpen && (
              <div
                style={{
                  position: 'absolute',
                  top: '100%',
                  left: 0,
                  width: '100%',
                  background: '#fff',
                  borderRadius: '8px',
                  marginTop: '4px',
                  boxShadow: '0 2px 8px rgba(0,0,0,0.15)',
                  width:"231px",
                  zIndex: 10,
                }}
              >
                {languages.map((lang) => (
                  <div
                    key={lang.code}
                    onClick={() => selectLanguage(lang)}
                    style={{
                      padding: '8px 12px',
                      cursor: 'pointer',
                      display: 'flex',
                      alignItems: 'center',
                      gap: '8px',
                      width:"231px",
                      backgroundColor: selected.code === lang.code ? '#e2e8f0' : 'white',
                    }}
                    onMouseEnter={(e) => (e.currentTarget.style.backgroundColor = '#edf2f7')}
                    onMouseLeave={(e) => (e.currentTarget.style.backgroundColor = selected.code === lang.code ? '#e2e8f0' : 'white')}
                  >
                    <img src = {lang.flag}/>
                    <span>{lang.label}</span>
                  </div>
                ))}
              </div>
            )}
            </div>
            </div>
          </div>

        );

  const renderContent = () => {
    switch (activeSection) {
      case 'profile':
        return renderProfileContent( );
      case 'personalization':
        return  renderPersonalisierenContent();
      case 'language':
        return  renderSpracheContent();
      case 'home':
        return  RenderHomeButtonnContent ();
      case 'support':
        return renderSupportContent();
      default:
        return renderProfileContent();
    }
  };

  if (!isOpen) return null;

  return (
    <div style={{ 
      position: 'fixed',
      top: '60px', // Space for header
      left: 0,
      right: 0,
      bottom: 0,
      backgroundColor: '#f7fafc',
      zIndex: 10,
    
    }}>
      {/* Header bar with close button */}
        <button
          onClick={onClose}
          style={{ 
          position: 'absolute',
          top: '5px',
          right: '5px',
          padding: '0px',
    
          border: 'none',
          backgroundColor: 'transparent',
          cursor: 'pointer'
          }}
          onMouseOver={(e) => e.currentTarget.style.backgroundColor = 'white'}
          onMouseOut={(e) => e.currentTarget.style.backgroundColor = 'transparent'}
        >
          <svg style={{ width: '20px', height: '20px' }} fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
          </svg>
        </button>

      
      <div style={{ display: 'flex', height: 'calc(100% - 0px)' }}>
        {/* Sidebar */}
        <div style={{ 
          width: '336px', 
          backgroundColor: 'white', 
          boxShadow: '0 1px 3px 0 rgba(0, 0, 0, 0.1)', 
          height: '100%' 
        }}>
          <div style={{ padding: '4px' }}>
            <div style={{ marginBottom: '24px',marginTop:"20px", marginLeft:"20px" }}>
              <h2 style={{ 
                fontSize: '13px', 
                fontWeight: '600', 
                color: '#2d3748', 
                marginBottom: '4px' ,
                fontFamily:"GoldbeckNextSemiBold2"
              }}>
                GOLDBECK Business Workspace
              </h2>
              <p style={{ 
                fontSize: '12px', 
                color: '#27292B' ,
                fontFamily:"GoldbeckNextSemiBold2",
                marginTop:"1px"
              }}>
                User Settings
              </p>
            </div>

            <nav style={{ display: 'flex', flexDirection: 'column', gap: '24px' }}>
              {sidebarSections.map((section) => (
                <div key={section.title}>
                  <h3 style={{ 
                    fontSize: '12px', 
                    fontWeight: '500', 
                    color: '#27292B', 
                    textTransform: 'uppercase', 
                    letterSpacing: '0.05em', 
                    marginBottom: '12px' ,
                    marginLeft:"20px",
                    fontFamily:"GoldbeckNextSemiBold2"
                  }}>
                    {section.title}
                  </h3>
                  <ul style={{ 
                    listStyle: 'none', 
                    padding: 0, 
                    margin: 0, 
                    display: 'flex', 
                    flexDirection: 'column', 
                    gap: '4px' 
                  }}>
                    {section.items.map((item) => {
                      const Icon = item.icon;
                      const isActive = activeSection === item.id;
                      return (
                        <li key={item.id}>
                          <button
                            onClick={() => setActiveSection(item.id)}
                            style={{
                              width: '100%',
                              display: 'flex',
                              alignItems: 'center',
                              padding: '8px 12px',
                              fontSize: '13px',
                              borderRadius: '6px',
                              border: 'none',
                              outline:"none",
                              cursor: 'pointer',
                              backgroundColor: "white",
                              fontFamily: isActive ? '"GoldbeckNextRegular"' : 'GoldbeckNextSemiBold2',
                              
                              transition: 'all 0.2s'
                            }}
                            onMouseOver={(e) => {
                              if (!isActive) {
                                e.currentTarget.style.fontFamily = 'GoldbeckNextSemiBold2';
                               
                              }
                            }}
                            onMouseOut={(e) => {
                              if (!isActive) {
                                e.currentTarget.style.fontFamily="GoldbeckNextRegular";
                               
                              }
                            }}
                          >
                            <Icon style={{ 
                              width: '16px', 
                              height: '16px', 
                              marginRight: '12px' 
                            }} />
                            <span style={{ 
                              flex: 1, 
                              textAlign: 'left' 
                            }}>
                              {item.label}
                            </span>
                            {/* {isActive && (
                              <ChevronRight style={{ 
                                width: '16px', 
                                height: '16px' 
                              }} />
                            )} */}
                          </button>
                        </li>
                      );
                    })}
                  </ul>
                   
                </div>
                
              ))}
            </nav>
          </div>
           <div style={{display: "flex"}}>
            <img src='\assets\GoldbeckLogo.png' style={{bottom:"20px", left:"20px", position:"absolute"}}/>
            <h1 style={{bottom:"10px", left:"260px", position:"absolute", color:"#808489",fontSize:"11px"}}>Version 1.0</h1>
           </div>
        </div>

        {/* Main Content */}
        <div style={{ 
          flex: 1, 
          overflow: 'hidden' 
        }}>
          {renderContent()}
        </div>
      </div>
    </div>
  );
};

export default SettingsComponent;